var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-blue-200 font-bold text-xl"},[_vm._v("\n    Overwatch\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }